import { render } from "./Reservation.vue?vue&type=template&id=2d9c3017&bindings={\"gite\":\"options\",\"imageUrls\":\"options\"}"
import script from "./Reservation.vue?vue&type=script&lang=js"
export * from "./Reservation.vue?vue&type=script&lang=js"
script.render = render

export default script